import type { PixelCrop } from 'react-image-crop'

type HelperProps = {
  crop: PixelCrop
  image: HTMLImageElement | null
  containerWidth?: number
  containerHeight?: number
}

const adjustCropToImage = ({
  crop,
  image,
  containerWidth,
  containerHeight,
}: HelperProps): PixelCrop => {
  const containerW = containerWidth ?? image?.width ?? 0
  const containerH = containerHeight ?? image?.height ?? 0

  const padX = image ? Math.max(0, containerW - image.width) / 2 : 0
  const padY = image ? Math.max(0, containerH - image.height) / 2 : 0

  return {
    ...crop,
    x: (crop.x ?? 0) - padX,
    y: (crop.y ?? 0) - padY,
  } as PixelCrop
}

export default adjustCropToImage
